import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
// Rxjs
import { Observable } from 'rxjs';
import { TenantConfService } from 'src/app/services/tenant-conf.service';
// ENV
import { environment } from '../../../environments/environment';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class RequestInterceptor implements HttpInterceptor {
  constructor(private tenantService: TenantConfService, @Inject(PLATFORM_ID) private platformId: Object) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const includeAssets = request.url.includes('assets');
    const includeSitum = request.url.includes('situm');
    const includeTracking = request.url.includes('tracking');
    const includeBlog = request.url.includes('wp-json');
    const includeShop = request.url.includes('shop') && !request.url.includes('promotion');
    const includeService = request.url.includes('service');
    const includeTenant = request.url.includes('tenant');
    const includeAuth = request.url.includes('auth');

    if (includeSitum || includeTracking || includeBlog) {
      return next.handle(request);
    }

    if (includeShop || includeService || includeTenant || includeAuth) {
      if (isPlatformServer(this.platformId)) {
        request = request.clone({
          url: `http://localhost:3000${request.url}`,
        });
      }
      return next.handle(request);
    }

    if (includeAssets) {
      if (isPlatformServer(this.platformId)) {
        request = request.clone({
          url: `http://localhost:4200${request.url}`,
        });
      }
      return next.handle(request);
    }

    const tenantUuid = this.tenantService.getTenantFromUrl();

    request = request.clone({
      url: !request.url.includes('change-password')
          ? `${environment.baseUrl}/${tenantUuid}${request.url}`
          : `${environment.apiEnvDomain}/api/app/${tenantUuid}${request.url}`,
    });

    return next.handle(request);
  }
}
